"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "m2.3979 2.414 19.1846 19.1907-1.3978 1.3965L12 14.814v4.1822l-4-3.9961H4v-6h2.1879L1 3.8106l1.3979-1.3965zm7.5064 4.68L12 9.1903V4.9962L9.9043 7.094zm5.252 5.2536 1.6671 1.6676c.7701-2.1555.2137-4.6387-1.4092-6.2616L14 9.1678c.8311.8311 1.2581 2.0104 1.1563 3.1798z"
  }), _react.default.createElement("path", {
    d: "m17.5937 14.7857 1.4945 1.4951c1.8726-3.4527 1.231-7.8649-1.5527-10.6486l-1.4142 1.4143c2.011 2.011 2.6038 5.138 1.4724 7.7392z"
  })];
};

exports.default = _default;